var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.8754 0C4.87164 0 3.24414 1.5624 3.24414 3.48601C3.24414 5.40681 4.87164 6.97202 6.8754 6.97202C8.87915 6.97202 10.5067 5.40961 10.5067 3.48601C10.5067 1.5624 8.87915 0 6.8754 0ZM6.8754 5.85201C5.51623 5.85201 4.41081 4.79081 4.41081 3.48601C4.41081 2.1812 5.51623 1.12 6.8754 1.12C8.23457 1.12 9.33999 2.1812 9.33999 3.48601C9.33999 4.79081 8.23457 5.85201 6.8754 5.85201Z",
    fill: "#0099CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.17292 7.84006H5.57708C2.43292 7.84006 -0.125 10.2957 -0.125 13.314V13.44C-0.125 13.748 0.1375 14 0.458333 14H13.2917C13.6125 14 13.875 13.748 13.875 13.44V13.314C13.875 10.2957 11.3171 7.84006 8.17292 7.84006ZM1.065 12.88C1.2925 10.682 3.22917 8.96005 5.57708 8.96005H8.17292C10.5208 8.96005 12.4575 10.682 12.685 12.88H1.065Z",
    fill: "#0099CC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.dad763d9.svg";
export { ForwardRef as ReactComponent };